import { MouseEvent, useCallback } from 'react'

import { ListingCard } from '@lib/components'

import { TourInfo } from './TourInfo'
import styles from './styles.module.scss'

import { ListingCardProps } from './types'
import { useDialogListingCard } from './useDialogListingCard'

export const DialogListingCard = ({
  listingId,
  isTourRequest,
  tourDate,
  tourTime,
}: ListingCardProps) => {
  const { listing, listingImage, listingPrice, listingTitle, publicationLink } =
    useDialogListingCard(listingId)
  const tourInfoAvailable = isTourRequest && (tourDate || tourTime)
  const handleInnerCardClick = useCallback(() => {}, [])
  const handleCardClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation()
  }, [])

  return (
    (listing && (
      <a
        className={styles.listingCard}
        target="_blank"
        href={publicationLink}
        onClick={handleCardClick}
        rel="noreferrer"
      >
        {isTourRequest && (
          <>
            <TourInfo
              date={tourDate}
              location={listing?.location}
              tourTime={tourTime}
            />
            <hr className={styles.horizontalLine} />
          </>
        )}
        <ListingCard
          className={styles.innerCard}
          imageUrl={listingImage}
          imageAlt={listingTitle}
          title={listingTitle}
          price={listingPrice}
          onClick={handleInnerCardClick}
        />
      </a>
    )) ||
    (tourInfoAvailable && (
      <div className={styles.listingCard}>
        <TourInfo date={tourDate} tourTime={tourTime} />
      </div>
    ))
  )
}
